"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CHN_DISCLAIMER_DEFAULTS = exports.AIRASIA_GO = void 0;
var CHN_DISCLAIMER_DEFAULTS = {
  PRODUCT_ID: 'snap',
  BACKGROUND_COLOR: 'default'
};
exports.CHN_DISCLAIMER_DEFAULTS = CHN_DISCLAIMER_DEFAULTS;
var AIRASIA_GO = {
  URL: 'airasiago.com',
  COMPANY_NAME: 'AAE Travel Pte. Ltd'
};
exports.AIRASIA_GO = AIRASIA_GO;